import * as React from 'react'
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


export default function buyBoxColumn() {
	return {
		name: 'buyBox', label: 'Buy box',
		options: {
			customBodyRowRenderLite: value => {
				let backgroundColor = 'transparent'
				if (value >= 90)
					backgroundColor = 'success.light'
				else if (value >= 80)
					backgroundColor = 'success.lighter'
				else if (value >= 50)
					backgroundColor = 'error.lighter'
				else
					backgroundColor = 'error.light'

				return <Box sx={{ textAlign: 'center' }}>
					<Box component="span" sx={{
						backgroundColor: backgroundColor, py: 1, px: value < 10 ? 2.5 : 2, borderRadius: 1
					}}>
						{formatPercentage(value)}
					</Box>
				</Box>
			}
		}
	}
}